import userApi from 'api/userApi';

export default async function getMonitorUrl(user, viewMode, asPath) {
  try {
    if (viewMode === 'LEARNER' && user?._id) {
      const formData = new FormData();
      let dataForm = {
        firstName: user?.firstName,
        lastName: user?.lastName,
        bio: user?.bio ? user?.bio : '',
        language: user.language,
        twoFA: user.twoFA,
        mobile: user?.mobile,
        Mobilephoneno: user?.mobile?.slice(3, 13),
        mainPage: user?.mainPage ? user?.mainPage : null,
        monitoringUrl: asPath,
        monitoringTime: new Date(),
        dirtyFields: ['monitoringUrl', 'monitoringTime'],
        // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      formData.append('data', JSON.stringify(dataForm));
      await userApi.updateUserById(user?._id, formData);
    }
  } catch (error) {
    throw error;
  }
}
